export default __webpack_public_path__ + "assets/biozentrum.1d04aca.svg";